import React from 'react';

export const Time = () => {
    return (
        <svg
            width="36" height="36" xmlns="http://www.w3.org/2000/svg" fill="#fff">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="2.859 1.858 33.282 33.282">
                <path
                    paintOrder="stroke fill markers" fillRule="evenodd"
                    d="M19.5 1.858A16.64 16.64 0 1 0 36.141 18.5c-.01-9.186-7.455-16.63-16.64-16.64zm0 30.256A13.616 13.616 0 1 1 33.116 18.5c-.01 7.516-6.1 13.606-13.616 13.615zm1.513-14.241v-8.45a1.513 1.513 0 1 0-3.026 0v9.076c0 .4.16.786.444 1.07l4.538 4.538a1.513 1.513 0 0 0 2.14-2.14l-4.096-4.094zm0 0"/>
            </svg>
        </svg>
    );
};
